var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytic4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1C2.5 0.723858 2.72386 0.5 3 0.5H9.75C12.3561 0.5 14.4688 2.61266 14.4688 5.21875C14.4688 7.82484 12.3561 9.9375 9.75 9.9375H3C2.72386 9.9375 2.5 9.71364 2.5 9.4375V1ZM3.5 1.5V8.9375H9.75C11.8038 8.9375 13.4688 7.27256 13.4688 5.21875C13.4688 3.16494 11.8038 1.5 9.75 1.5H3.5ZM11.625 13C11.625 13.2761 11.4011 13.5 11.125 13.5H3.5L3.5 17.5312C3.5 17.8074 3.27614 18.0312 3 18.0312C2.72386 18.0312 2.5 17.8074 2.5 17.5312L2.5 13.5H1C0.723858 13.5 0.5 13.2761 0.5 13C0.5 12.7239 0.723858 12.5 1 12.5H11.125C11.4011 12.5 11.625 12.7239 11.625 13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic4);
export default __webpack_public_path__ + "static/media/analytic4.4037331c65f80f4e0d79f1aeedfdceda.svg";
export { ForwardRef as ReactComponent };